import { Dispatch } from "@reduxjs/toolkit";
import { firebaseSignup, logoutFunc, notify } from "../../gateway/Functions";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, FacebookAuthProvider, TwitterAuthProvider, signOut } from 'firebase/auth';



const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "bonga-61e58.firebaseapp.com",
    projectId: "bonga-61e58",
    storageBucket: "bonga-61e58.appspot.com",
    messagingSenderId: "280370963466",
    appId: "1:280370963466:web:7bf54f66039988469b6bf3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const facebookProvider = new FacebookAuthProvider();
const googleProvider = new GoogleAuthProvider();
const twitterProvider = new TwitterAuthProvider();
export const signInWithGoogle = (dispatch: Dispatch, navigate: any) => {
    signInWithPopup(auth, googleProvider)
        .then((result: any) => {
            firebaseSignup(result, dispatch)
                .then(() => {
                    navigate("/")
                })
        }).catch((err: any) => {
            console.warn(err);
            notify("error", "bottomLeft", "Social Account Error", `invalid Credentials`);
        })
}
export const signInWithFacebook = (dispatch: Dispatch, navigate: any) => {
    signInWithPopup(auth, facebookProvider)
        .then((result: any) => {
            firebaseSignup(result, dispatch)
                .then(() => {
                    navigate("/")
                })
        }).catch((err: any) => {
            console.warn(err);
            notify("error", "bottomLeft", "Error", `invalid Credentials`);
        })
}
export const signInWithTwitter = (dispatch: Dispatch, navigate: any) => {
    signInWithPopup(auth, twitterProvider)
        .then((result: any) => {
            firebaseSignup(result, dispatch)
                .then(() => {
                    navigate("/")
                })
        }).catch((err: any) => {
            console.warn(err);
            notify("error", "bottomLeft", "Error", `invalid Credentials`);
        })
}
export const userSignOut = async (dispatch: Dispatch, navigate: any) => {
    signOut(auth)
        .then(() => {
        }).catch((err: any) => {
            console.warn(err);
        })
    await logoutFunc(dispatch)
        .then(() => {
            notify("info", "bottomLeft", "Logged Out", `You have successfully logged out.`);
            navigate("/login")
            localStorage.clear()
        })
        .catch((e: any) => {
            console.warn(e)
        })
}
